module.exports = __webpack_public_path__ + "static/media/img-product-management.57793866.jpeg";